export default function CardAnalytics({ title, value, valueUS, status, description }) {
    return (
        <div className='col-lg-3 col-sm-6 col-xs-6 col-md-6'>
            <div className="ibox">
                <div className="ibox-title">
                    <h5 className={`${status}`}>{title}</h5>
                </div>
                <div className="ibox-content">
                    <div className='d-flex justify-content-between'>
                        <div>
                            <h1 className="no-margins">{value}</h1>
                            <small>Canada</small>
                        </div>
                        <div>
                            <h1 className="no-margins">{valueUS}</h1>
                            <small>United States</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
